import { Observable } from 'rxjs';

import { RequestResponse } from '@shure/shared/angular/data-access/system-api/models';

import { SpectrumScannerDevice, SpectrumScannerRoomDevice } from './models';

export abstract class SpectrumScannerApiService {
	public abstract getDevice$(deviceId: string): Observable<SpectrumScannerDevice>;
	public abstract getDevices$(deviceIds: string[]): Observable<SpectrumScannerDevice[]>;
	public abstract getDevicesInRoom$(roomId: string): Observable<SpectrumScannerRoomDevice[]>;
	public abstract getAllScannableDeviceIds$(): Observable<string[]>;
	public abstract startScan(deviceIds: string[]): Observable<RequestResponse<string>[]>;
	public abstract endScan(deviceIds: string[]): Observable<RequestResponse<string>[]>;
	public abstract clearScan(deviceIds: string[]): Observable<RequestResponse<string>[]>;
}
